import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface ResetPasswordRequestFormProps {
    formData: {
        email: string;
    };
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isDrawer?: boolean;
}

export const ResetPasswordRequestForm: React.FC<ResetPasswordRequestFormProps> = ({
    formData,
    handleInputChange,
    isDrawer
}) => {
    return (
        <div className={cn("space-y-4", isDrawer ? "px-4" : "")} dir="rtl">
            <div className="space-y-2">
                <Label htmlFor="email">כתובת מייל</Label>
                <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="הכנס את כתובת המייל שלך"
                    required
                    className="text-right"
                    dir="rtl"
                />
            </div>
        </div>
    );
};
